// packages/ui/src/customComponents/GroupList/columns.tsx

import type { ColumnDef } from "@tanstack/react-table";
import type { Group } from "./data-table"
import { Button } from "../../components/button"
import { useNavigate } from "react-router-dom"

type ColumnOptions = {
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

// EXPORT as getGroupColumns (not groupColumns)
export const groupColumns = ({ onEdit, onDelete }: ColumnOptions): ColumnDef<Group>[] => [
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ row }) => row.original.name,
  },
  {
    accessorKey: "uom",
    header: "UOM",
    cell: ({ row }) => row.original.uom,
  },
  {
    accessorKey: "bom",
    header: "BOM",
    cell: ({ row }) => {
      const bomValue = row.original.bom;
      return Boolean(bomValue) ? "Yes" : "No";
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => (
      <span
        className={`px-2 py-1 text-xs rounded ${
          row.original.status === "Enabled" ? "bg-green-200" : "bg-red-200"
        }`}
      >
        {row.original.status}
      </span>
    ),
  },
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => {
      const navigate = useNavigate()
      const group_master_id = row.original.group_master_id
      return (
        <div className="flex gap-2">
          <Button onClick={() => navigate(`/group_masters/edit/${group_master_id}`)}>Edit</Button>
          <Button variant="destructive" onClick={() => onDelete(group_master_id)}>
            Delete
          </Button>
        </div>
      );
    },
  },
];
